import { useEffect } from 'react';

function useEffectOnLoad(fn) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => fn(), []); // [] => run effect only once
}

export default useEffectOnLoad;
